// Единственное событие, о котором рассказывает клиент. SMY-82 · P8 Э8.1
//
// Сервер видит, что экран 04 показан, — шит собирает он. Что человек на нём
// выбрал, сервер не видит ничем: «подтвердил» ещё угадывается по запуску, а
// «отменил» — это уход с экрана, и следа он не оставляет.
//
// ПРАВИЛО ЭТОГО МОДУЛЯ: он не бросает и не заставляет ждать. Отчёт, который
// читают раз в неделю, не имеет права ни уронить запуск, ни задержать его —
// то же правило, что у службы событий на сервере. Поэтому метод возвращает
// void и глотает любую ошибку: не записалось так не записалось.

import {
  confirmDecisionOf, type ScenarioId, type SignupDecision, type SignupStep, type UnitId,
} from '@smyslika/core'

import type { Client } from './client.ts'

export const createEvents = (client: Client) => ({
  /**
   * Чем кончился экран 04.
   *
   * Принимает факты, а не готовое решение: правило «что считать отказом»
   * живёт в ядре (`confirmDecisionOf`) и обязано быть одним на веб, iOS и
   * Android. Иначе доля отмен в отчёте начнёт зависеть от платформы.
   */
  confirmDecided(facts: {
    ran: boolean
    skipAsked: boolean
    declined: boolean
    unit?: UnitId
    scenario?: ScenarioId
  }): void {
    void client
      .request('/v1/events/confirm', {
        method: 'POST',
        body: {
          decision: confirmDecisionOf(facts),
          ...(facts.unit != null ? { unit: facts.unit } : {}),
          ...(facts.scenario != null ? { scenario: facts.scenario } : {}),
        },
      })
      .catch(() => undefined)
  },

  /**
   * Показ и решение на предложении зарегистрироваться. SMY-180
   *
   * ⚠️ ЭТО НЕ ОТКАЗ. Отказ, двигающий лестницу, — `auth.declineSignup()`, и
   * он меняет состояние на сервере. Здесь только журнал, и разделены они
   * намеренно: потерянная запись в журнале допустима (аналитика не роняет
   * продукт), а потерянный отказ означал бы просьбу на каждом старте.
   *
   * Ступень передаётся перечислением, а не числом: пороги правятся из
   * конфигурации, и число разбило бы ряд надвое при первой же правке.
   */
  signupPrompt(step: SignupStep, decision?: SignupDecision): void {
    void client
      .request('/v1/events/signup', {
        method: 'POST',
        body: { step, ...(decision != null ? { decision } : {}) },
      })
      .catch(() => undefined)
  },
})

export type EventsApi = ReturnType<typeof createEvents>
